export default "__VITE_ASSET__C$0Moqoq__"